import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from 'react';
import { useSelector } from 'react-redux';
import { selectStoreConfig } from '../../containers/Layout/selectors';
import useAdyenPayment from 'helpers/hooks/useAdyenPayment';
import { selectAdyenPaymentMethods } from 'containers/ReviewOrder/selectors';

const AdyenContext = createContext(null);

export const AdyenProvider = ({
  children,
  toPay: initialToPay,
  isSaveCard,
}) => {
  const storeConfig = useSelector(selectStoreConfig);
  const adyenPaymentMethods = useSelector(selectAdyenPaymentMethods);
  const [toPay, setToPay] = useState(initialToPay);

  useEffect(() => {
    setToPay(initialToPay);
  }, [initialToPay]);

  const adyenConfig = useMemo(
    () => ({
      clientKey: window.storeConfigInitial.adyenClientKey,
      paymentMethods: adyenPaymentMethods,
      countryCode: window.storeConfigInitial.countryIdentifier,
      currency: window.storeConfigInitial.currencyCode,
      toPay,
      isSaveCard,
      storeName: window.storeConfigInitial.name,
      adyenMerchantAccount: window.storeConfigInitial.adyenMerchantAccount,
      gpayMerchantId: window.storeConfigInitial.gpayMerchantId,
      gpayJWTToken: window.storeConfigInitial.gpayJWTToken,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [storeConfig, toPay, JSON.stringify(adyenPaymentMethods), isSaveCard]
  );

  const adyen = useAdyenPayment(adyenConfig);

  return (
    <AdyenContext.Provider value={{ ...adyen, setToPay }}>
      {children}
    </AdyenContext.Provider>
  );
};

export const useAdyen = () => useContext(AdyenContext);
